import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import LazyImage from "../../../../../../../../components/app-specific/lazy-image";
import {UserHomepageControllerContext, UserHomepageViewContext} from "../../../../../../index";
import {UserHomepageEventEmitter} from "../../../../../../models";
import ObserversService from "../../../../../../../../../core/services/observers";
import {bannerWidthToHeightRatio} from "../../../../../../../../../core/constants/enums";
import debounce from "lodash/debounce";
import useIsMounted from "../../../../../../../../hooks/use-is-mounted";

const UserWebHomepageBanner = ({component, tabId}) => {
    const {zoom} = useContext(UserHomepageViewContext);
    const controller = useContext(UserHomepageControllerContext);
    const [bannerHeight, setBannerHeight] = useState(187);
    /**@type {React.MutableRefObject<HTMLDivElement>}*/
    const containerRef = useRef();
    const isMounted = useIsMounted();

    const banner = useMemo(() => component?.content?.banners?.length
            ? component?.content?.banners[0]
            : null,
        [component]);

    /**
     * With each change in the zoom value of the view context:
     * - attaches an observer to recompute the height of the banner and to adjust the size of the banner
     */
    useEffect(() => {
        if (!containerRef.current)
            return;
        const throttledCallback = debounce((entries, observer) => adjustBannerSize(entries, observer), 100);
        const observer = ObserversService.newResizeObserver(throttledCallback);
        ObserversService.observeResizeObserver(observer, containerRef.current)
        throttledCallback([containerRef.current]);
        return () => ObserversService.disconnectResizeObserver(observer);
    }, [containerRef, zoom])

    /**
     * Recomputes the height of the banners and to adjust the size of the banner.
     * @param {ResizeObserverEntry[] | Element[]} entries
     */
    const adjustBannerSize = (entries) => {
        requestAnimationFrame(() => {
            if (!isMounted())
                return;
            const entry = entries[0];
            const width = entry?.contentRect?.width ?? entry?.getBoundingClientRect()?.width ?? 0;
            setBannerHeight(((width / bannerWidthToHeightRatio)));
        })
    }

    /**
     * Invokes the appropriate controller callback for the click of a category.
     */
    const onBannerClicked = () => {
        if (!banner)
            return;
        controller.clickContent(tabId, component.id, banner?.id, UserHomepageEventEmitter.view);
    }

    return (
        <>
            <div ref={containerRef} className={'user-web-homepage-banner'} onClick={onBannerClicked}>
                <div
                    key={banner?.id}
                    id={banner?.webViewElementId}
                    className={'image'}
                >
                    {
                        !banner &&
                        <p className={'no-banner'}>
                            There is no banner to preview! add your banner first.
                        </p>
                    }
                    {
                        !!banner &&
                        <LazyImage
                            height={bannerHeight}
                            src={banner?.imageName}
                            alt={banner?.imageName ?? ''}
                        />
                    }

                </div>
            </div>
        </>
    )
}

export default UserWebHomepageBanner;
